// GoogleAnalytics.js

// Initialize the data layer
window.dataLayer = window.dataLayer || [];

// Define the gtag function globally
window.gtag = function () {
  window.dataLayer.push(arguments);
};

// Function to initialize Google Analytics
export const initGA = () => {
  // Initialize Google Analytics tracking
  window.gtag("js", new Date());
  window.gtag("config", "G-028JRR5541");
};
